import uuidv4 from 'uuid/v4';

export default class Source {
  uid = uuidv4();
  url = '';
  methods = [];
  is_api_key_req = false;
  api_key = '';
  channels = new Map();
  feeds = new Map();
  channelsAreLoading = false;
  channelsAreLoaded = false;
  constructor(initializer = {}) {
    Object.assign(this, initializer);
  }
}



// WEBPACK FOOTER //
// ./src/models/source/Source.js